import {
  formatCompactCurrency,
  formatCurrency,
  formatPercent,
} from "./analyticsUtils";

const formatValue = (value, tone) => {
  if (tone === "currency") return formatCurrency(value);
  if (tone === "compactCurrency") return formatCompactCurrency(value);
  if (tone === "percent") return formatPercent(value);
  return value ?? "-";
};

const AnalyticsKpiCards = ({ items = [], loading = false, error = "" }) => {
  return (
    <div className="grid grid-cols-1 gap-4 md:grid-cols-2 xl:grid-cols-4">
      {items.map((item) => (
        <div
          key={item.label}
          className="rounded-3xl bg-white p-4 shadow min-h-[132px]"
        >
          <div className="text-sm font-medium text-zinc-500">{item.label}</div>
          {loading ? (
            <div className="mt-4 h-8 w-24 animate-pulse rounded bg-zinc-200" />
          ) : error ? (
            <div className="mt-3 text-sm text-red-600">{error}</div>
          ) : (
            <>
              <div className="mt-2 text-2xl font-semibold text-zinc-900">
                {formatValue(item.value, item.tone)}
              </div>
              {item.helpText ? (
                <div className="mt-2 text-sm text-zinc-500">{item.helpText}</div>
              ) : null}
            </>
          )}
        </div>
      ))}
    </div>
  );
};

export default AnalyticsKpiCards;
